const MapConstants = {
    defaultZoomUnit: 17,
    maxZoomUnit: 15,
    selectedMarker: '#008060',
    defaultMarker: '#352654',
    lat: 21.3448461,
    lng: -157.9306128,
    SVGMaker: color => ({
        path: 'M12 2C8.13 2 5 5.13 5 9c0 4.63 6.43 11.19 6.67 11.43.17.17.39.26.62.26s.45-.09.62-.26C12.57 20.19 19 13.63 19 9c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
        fillColor: color,
        fillOpacity: 1,
        strokeWeight: 0,
        scale: 1.5,
        anchor: new window.google.maps.Point(12, 24),
    }),
}

export default MapConstants
